let 
$roleInput,
$filterRole,
$filterTypeReset,
$filterRoleReset,
$filters,
$filterType,
$typeInput,
$typeFilterArray = [],
$roleFilterArray = [],
$resubmitForm;

$(document).ready(function($) {

    $roleInput = $('.js-search-input-role');
    $filterTypeReset = $('.js-search-remove-type'),
    $filterRoleReset = $('.js-search-remove-role'),
    $filters = $('.js-search-filter');
    $filterType = $('.js-search-filter-type');
    $filterRole = $('.js-search-filter-role');
    $typeInput = $('.js-search-input-type'),
    $resubmitForm = $('.js-search-resubmit-form');

    /* Toggler for all the filter items */
    if ( $filters.length > 0 ) {
        $filters.find('.c-checkselect__title').on('click', function() {
            $(this).parent().toggleClass('is-active');
        });
    };

    /* Function to change the array that goes into te hidden input */
    const changeFilterArray = (item, array, field) => {
        let filter_item = item.attr('name');

        /* Add */
        if( item.is(':checked')) {
            array.push(filter_item)
        };
        
        /* Remove */
        if( !item.is(':checked')) {
            let index = array.indexOf(filter_item);
            if (index !== -1) {
                array.splice(index, 1);
            }
        };
        
        field.val( array );
    };


    /* Filter Type -> change execute the change filter function */
    if ( $filterType.length > 0 ) {
        
        $filterType.each(function() {
            let item = $(this);
            changeFilterArray(item, $typeFilterArray, $typeInput)
        })

        $filterType.on('change', function() {
            $resubmitForm.removeClass("d-none");
            let item = $(this);
            changeFilterArray(item, $typeFilterArray, $typeInput)
        });
    };


    /* Filter Type -> remove item from list */
    if ( $filterTypeReset.length > 0 ) {
        $filterTypeReset.on('click', function() {
            
            let item = $(this).attr('data-remove');
            let index = $typeFilterArray.indexOf(item);
            if (index !== -1) {
                $typeFilterArray.splice(index, 1);
            }

            $typeInput.val( $typeFilterArray );
            $searchForm.submit();
        })
    };

    /* Filter Role -> remove item from list */
    if ( $filterRoleReset.length > 0 ) {
        $filterRoleReset.on('click', function() {

            let item = $(this).attr('data-remove');
            let index = $roleFilterArray.indexOf(item);
            if (index !== -1) {
                $roleFilterArray.splice(index, 1);
            }

            $roleInput.val( $roleFilterArray );
            $searchForm.submit();
        })
    };

    /* Filter Type -> change execute the change filter function */
    if ( $filterRole.length > 0 ) {
        
        $filterRole.each(function() {
            let item = $(this);
            changeFilterArray(item, $roleFilterArray, $roleInput)
        })

        $filterRole.on('change', function(e) {
            $resubmitForm.removeClass("d-none");
            let item = $(this);
            changeFilterArray(item, $roleFilterArray, $roleInput)
        });
    }

    /* Apply filter */
    if ( $resubmitForm.length > 0 ) {
        $resubmitForm.on('click', function() {
            $searchForm.submit();
        })
    }
});
